/* ============================================================
   LLAVEROS PREMIUM THEME - Main JS
   ============================================================ */

(function () {
  'use strict';

  /* ?? Utility ?? */
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];
  const money = (cents) => {
    const euros = cents / 100;
    return euros.toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });
  };
  const cleanUrl = (url) => {
    if (!url) return '';
    return url.split('?')[0].split('#')[0].replace(/^https?:/, '').trim();
  };

  /* ?????????????????????????????????????????
     MOBILE MENU
  ????????????????????????????????????????? */
  const hamburger = $('#hamburger');
  const mobileNav = $('#mobile-nav');
  const overlay   = $('#overlay');

  function openOverlay() {
    if (overlay) overlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
  }
  function closeOverlay() {
    if (overlay) overlay.classList.remove('is-visible');
    document.body.style.overflow = '';
  }

  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', () => {
      const open = mobileNav.classList.toggle('is-open');
      hamburger.classList.toggle('is-open', open);
      hamburger.setAttribute('aria-expanded', open);
      open ? openOverlay() : closeOverlay();
    });
  }

  /* ?????????????????????????????????????????
     CART STATE
  ????????????????????????????????????????? */
  let cartData = { items: [], item_count: 0, total_price: 0 };

  async function fetchCart() {
    const res = await fetch('/cart.js');
    cartData = await res.json();
    return cartData;
  }

  async function addToCart(formData) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
    });
    if (!res.ok) {
      const err = await res.json();
      throw new Error(err.description || 'Error al a�adir al carrito');
    }
    await fetchCart();
    renderCart();
    openCartDrawer();
    updateCartCount();
  }

  async function changeCartItem(key, quantity) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    });
    await fetchCart();
    renderCart();
    updateCartCount();
  }

  function updateCartCount() {
    $$('[data-cart-count]').forEach(el => {
      el.dataset.count = cartData.item_count;
      el.textContent  = cartData.item_count;
    });
  }

  /* ?????????????????????????????????????????
     CART DRAWER
  ????????????????????????????????????????? */
  const cartDrawer = $('#cart-drawer');

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    openOverlay();
    renderCart();
  }
  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    closeOverlay();
  }

  $$('[data-open-cart]').forEach(btn => btn.addEventListener('click', (e) => {
    e.preventDefault();
    openCartDrawer();
  }));

  const drawerClose = $('#cart-drawer-close');
  if (drawerClose) drawerClose.addEventListener('click', closeCartDrawer);

  if (overlay) {
    overlay.addEventListener('click', () => {
      closeCartDrawer();
      if (mobileNav) mobileNav.classList.remove('is-open');
      if (hamburger) hamburger.classList.remove('is-open');
      closeOverlay();
    });
  }

  function renderCart() {
    const body  = $('#cart-drawer-body');
    const total = $('#cart-drawer-total');
    if (!body) return;

    if (!cartData.items || cartData.items.length === 0) {
      body.innerHTML = `
        <div class="cart-drawer-empty">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>
          <p>Tu carrito est� vac�o.</p>
          <a href="/collections/all" class="btn btn-gold" style="margin-top:1.25rem">Ver productos</a>
        </div>`;
      if (total) total.textContent = money(0);
      return;
    }

    body.innerHTML = cartData.items.map(item => `
      <div class="cart-item" data-key="${item.key}">
        <a href="${item.url}">
          <img class="cart-item-img" src="${item.image || ''}" alt="${item.title}" width="80" height="80">
        </a>
        <div>
          <div class="cart-item-title">${item.product_title}</div>
          ${item.variant_title !== 'Default Title' ? `<div class="cart-item-variant">${item.variant_title}</div>` : ''}
          <div class="cart-item-price">${money(item.final_line_price)}</div>
          <div class="cart-item-qty">
            <button class="qty-minus" data-key="${item.key}" data-qty="${item.quantity - 1}" aria-label="Disminuir">?</button>
            <span>${item.quantity}</span>
            <button class="qty-plus"  data-key="${item.key}" data-qty="${item.quantity + 1}" aria-label="Aumentar">+</button>
          </div>
        </div>
        <button class="cart-item-remove" data-key="${item.key}" aria-label="Eliminar">?</button>
      </div>`).join('');

    if (total) total.textContent = money(cartData.total_price);

    $$('.qty-minus, .qty-plus', body).forEach(btn => {
      btn.addEventListener('click', () => changeCartItem(btn.dataset.key, parseInt(btn.dataset.qty)));
    });
    $$('.cart-item-remove', body).forEach(btn => {
      btn.addEventListener('click', () => changeCartItem(btn.dataset.key, 0));
    });
  }

  /* ?????????????????????????????????????????
     ADD TO CART BUTTONS
  ????????????????????????????????????????? */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();
    const variantId = btn.dataset.variantId || btn.dataset.addToCart;
    if (!variantId) return;

    btn.disabled = true;
    const orig = btn.innerHTML;
    btn.innerHTML = '<span class="spinner"></span>';
    
    try {
      const form = $('#product-form');
      const fd = new FormData();
      if (form) {
        const rawFd = new FormData(form);
        for (const [key, val] of rawFd.entries()) {
          fd.append(key, val);
        }
        const qtyInput = $('#qty-input');
        if (qtyInput) {
          fd.append('quantity', qtyInput.value);
        }
      } else {
        fd.append('id', variantId);
        fd.append('quantity', '1');
      }

      await addToCart(fd);
      showToast('�Producto a�adido al carrito!', 'success');
    } catch (err) {
      showToast(err.message, 'error');
    } finally {
      btn.innerHTML = orig;
      btn.disabled = false;
    }
  });

  /* ?????????????????????????????????????????
     PRODUCT PAGE - GALLERY
  ????????????????????????????????????????? */
  const mainImg = $('#product-main-img');
  if (mainImg) {
    $$('.product-thumb').forEach(thumb => {
      thumb.addEventListener('click', () => {
        $$('.product-thumb').forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
        const src = thumb.dataset.src;
        mainImg.src = src;

        // Sync variant selection when thumbnail is clicked
        const select = $('#variant-select');
        if (select) {
          const options = $$('option', select);
          const cleanThumbSrc = cleanUrl(src);
          const matchingOpt = options.find(opt => cleanUrl(opt.dataset.image) === cleanThumbSrc);
          if (matchingOpt) {
            select.value = matchingOpt.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
            // Now update the active variant buttons to match the selected option's values
            const vals = matchingOpt.dataset.options ? JSON.parse(matchingOpt.dataset.options) : [];
            $$('.variant-group').forEach((group, groupIdx) => {
              const valToSelect = vals[groupIdx];
              if (valToSelect) {
                $$('.variant-btn', group).forEach(btn => {
                  if (btn.dataset.value === valToSelect) {
                    btn.classList.add('is-active');
                  } else {
                    btn.classList.remove('is-active');
                  }
                });
              }
            });
            // Update prices, availability, addBtn ID, etc.
            const addBtn = $('#add-to-cart-btn');
            const priceEl = $('#product-price');
            const availabilityStatusEl = $('#product-availability-status');
            const isThumbAvail = matchingOpt.dataset.available === 'true';
            if (addBtn) {
              addBtn.dataset.variantId = matchingOpt.value;
              addBtn.disabled = !isThumbAvail;
              addBtn.innerHTML = isThumbAvail
                ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:18px;height:18px"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg> A�adir al carrito'
                : 'Agotado';
            }
            if (priceEl && matchingOpt.dataset.price) {
              priceEl.textContent = money(parseInt(matchingOpt.dataset.price));
            }
            if (availabilityStatusEl) {
              availabilityStatusEl.textContent = isThumbAvail ? '? En stock' : '? Agotado';
              availabilityStatusEl.style.color = isThumbAvail ? '#2d6a4f' : '#c0392b';
            }
          }
        }
      });
    });
  }

  /* ?????????????????????????????????????????
     PRODUCT PAGE - VARIANTS
  ????????????????????????????????????????? */
  $$('.variant-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const group = btn.closest('.variant-group');
      $$('.variant-btn', group).forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      updateSelectedVariant();
    });
  });

  function updateSelectedVariant() {
    const addBtn = $('#add-to-cart-btn');
    const priceEl = $('#product-price');
    const availabilityStatusEl = $('#product-availability-status');
    const select = $('#variant-select');
    if (!select) return;

    const activeOptions = $$('.variant-group').map(group => {
      const active = $('.variant-btn.is-active', group);
      return active ? active.dataset.value : null;
    });

    // find matching option
    const options = $$('option', select);
    for (const opt of options) {
      const vals = opt.dataset.options ? JSON.parse(opt.dataset.options) : [];
      const match = activeOptions.every((v, i) => !v || vals[i] === v);
      if (match) {
        select.value = opt.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        const isAvail = opt.dataset.available === 'true';
        if (addBtn) {
          addBtn.dataset.variantId = opt.value;
          addBtn.disabled = !isAvail;
          addBtn.innerHTML = isAvail
            ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:18px;height:18px"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg> A�adir al carrito'
            : 'Agotado';
        }
        if (priceEl && opt.dataset.price) {
          priceEl.textContent = money(parseInt(opt.dataset.price));
        }
        if (availabilityStatusEl) {
          availabilityStatusEl.textContent = isAvail ? '? En stock' : '? Agotado';
          availabilityStatusEl.style.color = isAvail ? '#2d6a4f' : '#c0392b';
        }
        if (mainImg && opt.dataset.image) {
          mainImg.src = opt.dataset.image;
          // Sync thumbnail selection
          const cleanOptImg = cleanUrl(opt.dataset.image);
          $$('.product-thumb').forEach(thumb => {
            if (cleanUrl(thumb.dataset.src) === cleanOptImg) {
              thumb.classList.add('is-active');
            } else {
              thumb.classList.remove('is-active');
            }
          });
        }
        break;
      }
    }
  }

  /* ?????????????????????????????????????????
     PRODUCT TABS
  ????????????????????????????????????????? */
  $$('.tab-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const target = btn.dataset.tab;
      $$('.tab-btn').forEach(b => b.classList.remove('is-active'));
      $$('.tab-panel').forEach(p => p.classList.remove('is-active'));
      btn.classList.add('is-active');
      const panel = $(`#tab-${target}`);
      if (panel) panel.classList.add('is-active');
    });
  });

  /* ?????????????????????????????????????????
     QUANTITY STEPPER (product page)
  ????????????????????????????????????????? */
  const qtyInput = $('#qty-input');
  $$('.qty-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      if (!qtyInput) return;
      let val = parseInt(qtyInput.value) || 1;
      if (btn.classList.contains('qty-dec') && val > 1) val--;
      if (btn.classList.contains('qty-inc')) val++;
      qtyInput.value = val;
    });
  });

  /* ?????????????????????????????????????????
     SORT SELECT (collection page)
  ????????????????????????????????????????? */
  const sortSelect = $('#sort-select');
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
    const cur = new URLSearchParams(window.location.search).get('sort_by') || '';
    sortSelect.value = cur;
  }

  /* ?????????????????????????????????????????
     COLLECTION FILTER TOGGLE (mobile)
  ????????????????????????????????????????? */
  const filterToggle = $('#filter-toggle');
  const sidebar = $('#collection-sidebar');
  if (filterToggle && sidebar) {
    filterToggle.addEventListener('click', () => {
      sidebar.classList.toggle('is-open');
      openOverlay();
    });
  }

  /* ?????????????????????????????????????????
     BACK TO TOP
  ????????????????????????????????????????? */
  const backToTop = $('#back-to-top');
  if (backToTop) {
    window.addEventListener('scroll', () => {
      backToTop.classList.toggle('is-visible', window.scrollY > 400);
    }, { passive: true });
    backToTop.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  }

  /* ?????????????????????????????????????????
     TOAST NOTIFICATIONS
  ????????????????????????????????????????? */
  let toastTimer;
  function showToast(msg, type = 'default') {
    let toast = $('#toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'toast';
      toast.className = 'toast';
      document.body.appendChild(toast);
    }
    toast.textContent = msg;
    toast.className = `toast${type === 'success' ? ' success' : ''}`;
    clearTimeout(toastTimer);
    requestAnimationFrame(() => toast.classList.add('is-visible'));
    toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 3000);
  }

  /* Newsletter form uses native Shopify customer form - no JS override needed */

  /* ?????????????????????????????????????????
     SIDEBAR HIERARCHY TOGGLE
  ????????????????????????????????????????? */
  $$('.sidebar-parent').forEach(link => {
    link.addEventListener('click', (e) => {
      const group   = link.closest('.sidebar-group');
      const subList = group.querySelector('.sidebar-sub-list');
      const toggle  = link.querySelector('.sidebar-toggle');
      if (!subList) return;
      const open = subList.classList.toggle('is-open');
      if (toggle) toggle.classList.toggle('is-open', open);
      // Only prevent default if clicking the toggle arrow area
      if (e.target === toggle) e.preventDefault();
    });
  });

  /* ?????????????????????????????????????????
     INIT - fetch cart on load
  ????????????????????????????????????????? */
  fetchCart().then(updateCartCount);

})();
